import React from "react";
import ReactDOM from "react-dom/client";
import { f_comment } from "./main_02.js";
import { Creator_A, Creator_A_title } from "./main_03.js";
import { f_comment_box } from "./main_04.js";

class main {
  constructor() {
    var post_id;
    var likes_array;
  }

  f_ill_post(Objects) {
    var size = Object.keys(Objects).length;

    if (size == 1) {
      for (var i = 0; i < size; i++) {
        this.loadpost(
          Objects[i][0],
          Objects[i][1],
          Objects[i][2],
          Objects[i][3],
          Objects[i][4],
          Objects[i][5]
        );
      }
    } else {
      for (var i = 0; i < size - 1; i++) {
        this.loadpost(
          Objects[i][0],
          Objects[i][1],
          Objects[i][2],
          Objects[i][3],
          Objects[i][4],
          Objects[i][5]
        );
      }
    }
  }

  openingchart(a) {
    document.getElementById("chart_03").style.display = "block";
    //console.log(a);

    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        // console.log(this.responseText);
      }
    };

    xhttp.open("POST", "php/getpost.php", true);
    xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhttp.send("method=getpost");
  }

  loadpost(id, text, time, likes, title, anonymous) {
    //console.log(id);
    //console.log(text);
    //console.log(time);
    //console.log(likes);
    if (title == "") {
      title = "sementara";
    }

    var mains = document.createElement("DIV");
    var tag_id = "C_container_tag" + id;
    mains.id = "app_2";
    mains.style.animation = "fadein 0.5s ease-in";
    document
      .getElementById("main")
      .insertBefore(mains, document.getElementById("app_1").nextSibling);
    localStorage.setItem("id", id);
    console.log(localStorage.getItem("id") + "ini id dia");
    this.post_id = id;

    var Hour = React.createClass({
      displayName: "Hour",

      getDefaultProps: function getDefaultProps() {
        return {
          time: 42,
        };
      },

      render: function render() {
        return React.createElement("p", null, this.props.time, " h");
      },
    });

    var Action = React.createClass({
      displayName: "Action",
      getDefaultProps: function getDefaultProps() {
        return {
          id: id,
          number: 0,
        };
      },
      _handleKeyPress: function _handleKeyPress(e) {
        //sambung besok la

        document.createElement("DIV").onClick = document.getElementById(
          "black_container"
        ).style.display = "block";
        document.getElementById("app").style.display = "none";
        var Post = React.createElement(
          "div",
          null,

          React.createElement(f_comment_box(id), null)
          // React.createElement(Barhux, null),
        );

        ReactDOM.render(Post, document.getElementById("black_container"));
        //alert("Great Shot!");
      },
      render: function render() {
        return React.createElement(
          "p",
          { className: "action-button", onClick: this._handleKeyPress },
          this.props.text
        );
      },
    });

    var Bar = React.createClass({
      displayName: "Bar",

      _shoot: function _shoot() {
        document.createElement("DIV").onClick = document.getElementById(
          "black_container"
        ).style.display = "block";
        document.getElementById("app").style.display = "none";
        var Post = React.createElement(
          "div",
          null

          //React.createElement(comment_box, null)
          // React.createElement(Barhux, null),
        );
        const roots = ReactDOM.createRoot(
          document.getElementById("black_container")
        );
        roots.render(Post);
        //alert("Great Shot!");
      },

      render: function render() {
        return React.createElement(
          "div",
          { className: "bar" },
          React.createElement(Action, {
            text: "Tanya Pendeta",
            onClick: this._shoot,
          })
          // React.createElement(Action, { text: "Share" })
        );
      },
    });

    var test = React.createElement(
      "div",
      null,
      React.createElement(
        "div",
        { className: "Container_app2" },
        React.createElement(Creator_A_title(id, anonymous, likes, title), null),
        //  React.createElement("h1",{},React.createElement("i",{className:"fa fa-question",style: {marginRight: "10px"}}),React.createElement("span",{}, title)),
        React.createElement(
          React.createClass({
            displayName: "Message",

            render: function render() {
              var container_id = "p_" + id;
              return React.createElement(
                "p",
                { className: "message", id: container_id },
                text
              );
            },
          }),
          null
        ),
        //18/2/2022, still going on with my project on tanyapendeta
        //React.createElement("div",{id: tag_id,className:"C_container_tag"},null),
        // React.createElement("p", {id:"likes"},React.createElement("i",{className: "fas fa-thumbs-up"},React.createElement("p",{id:id},likes.toString()))),
        React.createElement(Creator_A(id, anonymous, likes), null)
        //....kasi hilang bar dia dlu...React.createElement(Bar, null)
      ),
      React.createElement(f_comment(id), { id: id, className: "id testing" })
      // React.createElement(Barhux, null),
    );

    ReactDOM.render(test, mains);

    //generate the tag
    //18/2/2022, lets off the tag first
    //tag_generator(tag,tag_id);
  }

  tag_generator(words, id) {
    if (!this.isBlank(words)) {
      console.log(words);
      var con = JSON.parse(words);
      //var element = React.createElement("div",{className: "C_container_tag_tag"},React.createElement("tag",null,words));
      //let array = [1, 2, 3, 4, 5];
      con.forEach((element) => {
        let div = document.createElement("div");
        let span = document.createElement("span");

        div.className = "C_container_tag_tag";
        div.append(span.appendChild(document.createTextNode(element)));

        //ReactDOM.render(element,document.getElementById("C_container_tag"));
        document.getElementById(id).append(div);
      });
    }
  }

  isBlank(str) {
    return !!!str || /^\s*$/.test(str);
  }
}

export default new main();
